import {
  useDocumentListSearchParams,
  useRepositoryLanguages,
} from "./useDocumentListSearchParams"

export function useDocumentListLocales() {
  const { optimisticSearchParams, searchAction } = useDocumentListSearchParams()

  const { masterLocaleId, langs } = useRepositoryLanguages()

  const locale = optimisticSearchParams.language?.toString() || masterLocaleId

  function updateLocale(value: string) {
    searchAction.setValue("language", value)
  }

  return { locale, langs, updateLocale }
}
